import { object, string, boolean, number, array } from 'yup'
import { UNIT_OPTIONS, UNIT_STRENGTH_OPTIONS, FREQUENCY_OPTIONS } from 'constants/medicationOptions'

export const ConditionSchema = object().shape({
  condition: string().required(),
  conditionId: string().required(),
  id: string(),
  name: string().required(),
  value: boolean(),
})

export const OtherConditionSchema = object().shape({
  id: string().notRequired(),
  conditionId: string().notRequired(),
  value: string().required(),
})

export const MedicationSchema = object().shape({
  id: string().notRequired(),
  name: string().min(3, 'Medication name must be at least 3 characters').required(),
  dosage: number()
    .moreThan(0, 'Dosage must be a positive number')
    .typeError('You must specify a dosage amount')
    .required(),
  unit: string().oneOf(UNIT_OPTIONS).required(),
  strength: number()
    .moreThan(0, 'Strength must be a positive number')
    .typeError('You must specify a strength amount')
    .required(),
  unitStrength: string().oneOf(UNIT_STRENGTH_OPTIONS).required(),
  frequency: string().oneOf(FREQUENCY_OPTIONS).required(),
  active: boolean().required(),
})

export const MedicalHistorySchema = object().shape({
  memberId: string().required(),
  heightFt: number(),
  heightIn: number(),
  weightLbs: number(),
  // bpSystolic: number()
  //   .notRequired()
  //   .default(null),
  // bpDiastolic: number()
  //   .notRequired()
  //   .default(null),
  lifestyle: object(),
  conditions: array().of(ConditionSchema).default([]),
  other: array().of(OtherConditionSchema).default([]),
  medications: array().of(MedicationSchema).default([]),
  allergiesCompleted: boolean().default(false),
  medicationsCompleted: boolean().default(false),
  conditionsCompleted: boolean().default(false),
  familyHistoryCompleted: boolean().default(false),
  primaryCareCompleted: boolean().default(false),
})
